export const color = {
  grey: "#404040",
  lightGrey: "#595959",
  lightWhite: "#E0E0E1",
  buttonGrey: "#718096",
};
